import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
  CodeSandbox,
  Gateway,
  Codepen,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import AppHeader from "./AppHeader";
import { FILE_INPUT_HAS_SELECTION } from "@blueprintjs/core/lib/esm/common/classes";
import LiveDemoDetail from "./LiveDemoDetail";
import DemoListView from "./DemoListView";
import MMListView from "./MMListView";
import DocListView from "./DocListView";
import { SingleSelect } from "react-select-material-ui";
import Chip from "@material-ui/core/Chip";
import Rating from "@material-ui/lab/Rating";
import DatumContainer from "./DatumContainer";
import DemoListViewCard from "./DemoListViewCard";
import MMListViewCard from "./MMListViewCard";
import DocListViewCard from "./DocListViewCard";
class ListView extends Component {
  //const { push } = React.useContext(RouterContext);
  constructor(props) {
    super(props);
    this.state = {
      UserInfo: auth.getUserInfo(),
      searchResultData: undefined,
      srchResBackupData: undefined,
      bshowloader: true,
      bShowDemoDetail: false,
      bShowMMDetail: false,
      ArrExpSelect: [],
      Lang: undefined,
      filterON: false,
      OnFilterOpen: false,
      TabIndex: 0,
      IsFavouriteOnes: this.props.viaFav ? this.props.viaFav : false,
    };

    this.loadSearchData = this.loadSearchData.bind(this);
    this.setExpLevelValue = this.setExpLevelValue.bind(this);
    this.setLangChange = this.setLangChange.bind(this);
    this.ApplyFilter = this.ApplyFilter.bind(this);
    this.ResetFilter = this.ResetFilter.bind(this);
    this._OnFilterOpen = this._OnFilterOpen.bind(this);
    this._OnFilterClose = this._OnFilterClose.bind(this);
    this.closeitself = this.closeitself.bind(this);
    this.favouriteload = this.favouriteload.bind(this);
    this.OnActivate = this.OnActivate.bind(this);
    this.doTabCheck = this.doTabCheck.bind(this);
    this.closeandRefresh = this.closeandRefresh.bind(this);
    this.loadSearchDataForTab = this.loadSearchDataForTab.bind(this);
    this.setRating = this.setRating.bind(this);
    // this.loadDemoData = this.loadDemoData.bind(this);
    /* this._showDemoDetail = this._showDemoDetail.bind(this);
    this._hideDemoDetail = this._hideDemoDetail.bind(this);
    this._showMMDetail = this._showMMDetail.bind(this);
    this._hideMMDetail = this._hideMMDetail.bind(this); */
  }

  componentDidMount() {
    // document.body.style.overflow = "hidden";
    console.log("From List View , srchObj is ", this.props.srchObj);
    console.log("From List View , srchVal is ", this.props.srchVal);
    auth.verifyToken(true);
    if (auth.getSearchParam()) {
      localStorage.removeItem("search");
    }

    if (auth.getSearchdemoidParam()) {
      localStorage.removeItem("demoid");
    }

    if (this.props.viaFav) {
      this.favouriteload();
    } else {
      this.loadSearchData();
    }
    /*  this._demoInterval = setInterval(() => {
      console.log("Interval started!");
      this.loadDemoData();
    }, OnDemandRefreshInterval);

    this.loadDemoData(); */
  }

  componentWillUnmount() {
    // clearInterval(this._demoInterval);
  }
  /* 
  loadDemoData() {
    var endpoint = "/AllContent/GetPhysicalContents_Refreshed_Published";
    let token = auth.getToken();
    //var that=this;
    //if (this.state.UserActions.Content.ScheduleEvent) {
    callApiGetJson(endpoint, token).then((data) => {
      //console.log(data);
      var demoSearchData = this.state.searchResultData;
      if (demoSearchData !== undefined) {
        demoSearchData = demoSearchData.map(function (obj, index) {
          //console.log(obj);
          var currentIndex = 0;
          data.forEach(function (item, itemIndex) {
            if (item.Content_ID === obj.Content_ID) {
              //console.log(itemIndex);
              currentIndex = itemIndex;
            }
          });
          obj.Is_DemoReady = data[currentIndex].Is_DemoReady;
          obj.Content_Environments = data[currentIndex].Content_Environments;
          //console.log(index);
          return obj;
        });
        this.setState({ searchResultData: demoSearchData });
      }
    });
    //}
  } */

  /* _showDemoDetail(data) {
    console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowDemoDetail: false });
  }
  _hideDemoDetail() {
    this.setState({ bShowDemoDetail: false });
  }

  _showMMDetail(data) {
    console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowMMDetail: false });
  }
  _hideMMDetail() {
    this.setState({ bShowMMDetail: false });
  } */

  OnActivate(index) {
    console.log("Tab index is ", index);
    this.setState({ TabIndex: index });
    if (
      index === 0 ||
      index === 1 ||
      index === 2 ||
      index === 3 ||
      index === 4 ||
      index === 5
    ) {
      this.closeandRefresh(index);
      //  this.setState({ TabIndex: 4 });
      //  this.setState({ TabIndex: index });
    }
  }

  doTabCheck(tabNo) {
    console.log("Do Tab Check Hit with Tab No ", tabNo);
    this.setState({ TabIndex: tabNo });
  }

  closeandRefresh(tabNo) {
    console.log(
      " From List View Before Closing Itself Props but with specific Tab to be displayed ",
      this.props
    );
    console.log("Which Tab is ", tabNo);
    this.setState({ bshowloader: true, searchResultData: undefined });
    if (this.props.viaFav) {
      this.favouriteload();
    } else {
      this.loadSearchDataForTab(tabNo);
    }
    // this.props.hide();
  }

  closeitself() {
    console.log(
      " From List View Before Closing Itself Props are there is yes then ",
      this.props
    );
    this.setState({ bshowloader: true, searchResultData: undefined });
    if (this.props.viaFav) {
      this.favouriteload();
    } else {
      this.loadSearchData();
    }
    // this.props.hide();
  }

  setRating(newRate, contentType, contentID, contentRate) {
    console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Content Type is ", contentType);
    console.log("Content ID is ", contentID);
    console.log("Content Rating is ", contentRate);

    // var tempdemoData  = this.state.Demo;
    var ActionType = "";
    if (contentRate > 0) {
      ActionType = "Update";
    } else {
      ActionType = "Insert";
    }

    var RatingDataPost = {
      Rating_ID: null,
      ContentId: contentID,
      Rating_Value: newRate,
      Action_Type: ActionType,
      Content_Type: contentType,
    };

    var endpoint = "/AllContent/AddorUpdateRating";
    let token = auth.getToken();
    var postData = RatingDataPost;
    console.log("Rating Data is :", RatingDataPost);
    // this.setState({ showLoaderRating: true });
    //start below
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log(
        "Profile result Rating insert update response from API:",
        data
      );
      if (data) {
        console.log("UpdateMessage back from Rating Call response is : ");
        console.log(data);

        this.props.hide();
        // var tempdemoData = this.state.Demo;

        // if (tempdemoData != undefined) {
        //   tempdemoData.Content_Rating = newRate;
        /*           tempdemoData.map((demoitem) => {
            if(demoitem.Content_ID == contentID){
              demoitem.Content_Rating = newRate;
            }
          }); */
      }

      // this.setState({ Demo: tempdemoData, showLoaderRating: false });
      // auth.updateUserInfo(data);
      // this.props.hide();
      // this.props.history.push("/home");
      //this.props.router.replace("/home");
    });
  }

  favouriteload() {
    var endpoint = "/AllContent/GetAllUserFavorites";
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Get favorites data from API:');console.log(data);
      this.setState({
        searchResultData: data,
        bshowloader: false,
      });
    });
  }

  _OnFilterOpen() {
    this.setState({ OnFilterOpen: true });
  }

  _OnFilterClose() {
    this.setState({ OnFilterOpen: false });
    //this.setState({ searchResultData: res2, filterON: true, TabIndex: 2 });
  }

  loadSearchDataForTab(whichTabFor) {
    var SrchData;
    var endpoint;
    let token = auth.getToken();

    if (this.props.srchVal && this.props.srchVal.length >= 3) {
      endpoint = "/AllContent/SearchAllContentByString/" + this.props.srchVal;
      callApiGetJson(endpoint, token).then((data) => {
        console.log(
          "Search result data from API: for search string " +
            data.find((x) => x.PhyContent_Category === "Live")
        );

        var whichTab = whichTabFor;

        /*         if (data.filter((x) => x.PhyContent_Category === "Live").length > 0) {
          whichTab = 0;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Lab").length > 0
        ) {
          whichTab = 1;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Interactive").length > 0
        ) {
          whichTab = 2;
        } else if (
          data.filter((x) => x.Content_Type === "Multimedia").length > 0
        ) {
          whichTab = 3;
        } else if (
          data.filter((x) => x.Content_Type === "Document").length > 0
        ) {
          whichTab = 4;
        } else {
          whichTab = 0;
        } */
        // data.filter((x) => x.PhyContent_Category === "Lab");
        // console.log("All Lab Ones Are ", AllLive.length);
        //if(data.length===0){
        this.setState({
          searchResultData: data,
          bshowloader: false,
          TabIndex: whichTab,
        });
      });
    }
    if (this.props.srchObj && this.props.srchObj.MetadataName) {
      //is a metadata object
      SrchData = {
        MetadataID: this.props.srchObj.MetadataID,
        MetadataType: this.props.srchObj.MetadataType,
        MetadataName: this.props.MetadataName,
      };
      endpoint = "/AllContent/SearchAllContentByMetadata";
      callApiPostJson(endpoint, SrchData, token).then((data) => {
        console.log("Search result data from API for metadatamodel:" + data);

        var whichtTab = whichTabFor;

        /*         if (data.filter((x) => x.PhyContent_Category === "Live").length > 0) {
          whichtTab = 0;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Lab").length > 0
        ) {
          whichtTab = 1;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Interactive").length > 0
        ) {
          whichtTab = 2;
        } else if (
          data.filter((x) => x.Content_Type === "Multimedia").length > 0
        ) {
          whichtTab = 3;
        } else if (
          data.filter((x) => x.Content_Type === "Document").length > 0
        ) {
          whichtTab = 4;
        } else {
          whichtTab = 0;
        } */

        this.setState({
          searchResultData: data,
          bshowloader: false,
          TabIndex: whichtTab,
        });
      });
    }
  }

  ResetFilter() {
    var OrigSrchData = this.state.srchResBackupData;
    this.setState({
      searchResultData: OrigSrchData,
      filterON: false,
      ArrExpSelect: [],
      Lang: undefined,
      TabIndex: 0,
    });
    this._OnFilterClose();
  }

  ApplyFilter() {
    console.log("Language Selected is ", this.state.Lang);
    console.log("Expertises Selected are ", this.state.ArrExpSelect);
    var res1 = undefined;
    var res2 = undefined;
    if (this.state.searchResultData) {
      var ResData = this.state.searchResultData;
      // if (!this.state.filterON) {
      this.setState({ srchResBackupData: ResData });
      // }

      if (this.state.ArrExpSelect && this.state.ArrExpSelect.length > 0) {
        var res1 = this.state.searchResultData.filter((item) => {
          //  if(item.Content_ExpertiseLevel){
          return (
            item.Content_ExpertiseLevel &&
            this.state.ArrExpSelect.indexOf(
              item.Content_ExpertiseLevel.ExpertLevelName
            ) > -1
          );
          //}
        });
      }
      if (this.state.Lang) {
        if (res1) {
          res2 = res1.filter((item2) => {
            return (
              item2.Content_Language &&
              !item2.Content_Language != "English" &&
              item2.Content_Language.includes(this.state.Lang)
            );
          });
        } else {
          res2 = this.state.searchResultData.filter((item2) => {
            return (
              item2.Content_Language &&
              !item2.Content_Language != "English" &&
              item2.Content_Language.includes(this.state.Lang)
            );
          });
        }
      }
      console.log("Expertise Filter Result is ", res1);
      console.log("Language Filter Result is ", res2);

      if (res1 || res2) {
        if (res2) {
          var TBIdx = 0;
          if (this.state.TabIndex === 0) {
            TBIdx = 2;
          } else {
            TBIdx = 0;
          }
          this.setState({
            searchResultData: res2,
            filterON: true,
            TabIndex: TBIdx,
          });
        } else {
          var TIdx = 0;
          if (this.state.TabIndex === 0) {
            TIdx = 2;
          } else {
            TIdx = 0;
          }
          this.setState({
            searchResultData: res1,
            filterON: true,
            TabIndex: TIdx,
          });
          //this.setState({ searchResultData: res1, filterON: true, TabIndex: 0 });
        }
      }
    }
    this._OnFilterClose();
  }

  setExpLevelValue(value) {
    console.log("OnChange Fired from Filter exp level with value ", value);
    if (value) {
      this.setState({ ArrExpSelect: value });

      // (state) => {
      // const ArrExpSelect = [...state.ArrExpSelect, value];

      /* return {
          ArrExpSelect,
        };
      }); */
      //}
    }
  }

  setLangChange(value) {
    if (value) {
      this.setState({ Lang: value });
      // this.ApplyFilter();
    }
  }

  loadSearchData() {
    var SrchData;
    var endpoint;
    let token = auth.getToken();

    if (this.props.srchVal && this.props.srchVal.length >= 3) {
      endpoint = "/AllContent/SearchAllContentByString/" + this.props.srchVal;
      callApiGetJson(endpoint, token).then((data) => {
        console.log(
          "Search result data from API: for search string " +
            data.find((x) => x.PhyContent_Category === "Live")
        );

        var whichTab = 0;

        /*         if (data.filter((x) => x.PhyContent_Category === "Live").length > 0) {
          whichTab = 0;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Lab").length > 0
        ) {
          whichTab = 1;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Interactive").length > 0
        ) {
          whichTab = 2;
        } else if (
          data.filter((x) => x.Content_Type === "Multimedia").length > 0
        ) {
          whichTab = 3;
        } else if (
          data.filter((x) => x.Content_Type === "Document").length > 0
        ) {
          whichTab = 4;
        } else {
          whichTab = 0;
        } */
        // data.filter((x) => x.PhyContent_Category === "Lab");
        // console.log("All Lab Ones Are ", AllLive.length);
        //if(data.length===0){
        this.setState({
          searchResultData: data,
          bshowloader: false,
          TabIndex: whichTab,
        });
      });
    }
    if (this.props.srchObj && this.props.srchObj.MetadataName) {
      //is a metadata object
      SrchData = {
        MetadataID: this.props.srchObj.MetadataID,
        MetadataType: this.props.srchObj.MetadataType,
        MetadataName: this.props.MetadataName,
      };
      endpoint = "/AllContent/SearchAllContentByMetadata";
      callApiPostJson(endpoint, SrchData, token).then((data) => {
        console.log("Search result data from API for metadatamodel:" + data);

        var whichtTab = 0;

        /*         if (data.filter((x) => x.PhyContent_Category === "Live").length > 0) {
          whichtTab = 0;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Lab").length > 0
        ) {
          whichtTab = 1;
        } else if (
          data.filter((x) => x.PhyContent_Category === "Interactive").length > 0
        ) {
          whichtTab = 2;
        } else if (
          data.filter((x) => x.Content_Type === "Multimedia").length > 0
        ) {
          whichtTab = 3;
        } else if (
          data.filter((x) => x.Content_Type === "Document").length > 0
        ) {
          whichtTab = 4;
        } else {
          whichtTab = 0;
        } */

        this.setState({
          searchResultData: data,
          bshowloader: false,
          TabIndex: whichtTab,
        });
      });
    }
  }

  render() {
    console.log("Forced Tab State is ", this.state.TabIndex);
    var SrchResultDemo = undefined;
    var SrchResultAll = undefined;
    var SrchResultMM = undefined;
    var SrchResultDoc = undefined;

    var SrchResultDemo_Live = undefined;
    var SrchResultDemo_Interactive = undefined;
    var SrchResultDemo_Lab = undefined;

    var spinnercontent = "";
    var chippingcontent = "";
    var isStillLoading = this.state.bshowloader;

    if (this.state.searchResultData) {
      SrchResultAll = new Array();
      SrchResultDemo = new Array();
      SrchResultMM = new Array();
      SrchResultDoc = new Array();
      SrchResultDemo_Live = new Array();
      SrchResultDemo_Lab = new Array();
      SrchResultDemo_Interactive = new Array();

      this.state.searchResultData.map((item) => {
        SrchResultAll.push(item);
        if (item.Content_Type === "Physical") {
          SrchResultDemo.push(item);
        }
        if (item.Content_Type === "Multimedia") {
          SrchResultMM.push(item);
        }
        if (item.Content_Type === "Document") {
          SrchResultDoc.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Live"
        ) {
          SrchResultDemo_Live.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Lab"
        ) {
          SrchResultDemo_Lab.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Interactive"
        ) {
          SrchResultDemo_Interactive.push(item);
        }
      });
      isStillLoading = false;
    }

    /*     if (
      this.state.searchResultData !== undefined &&
      this.state.searchResultData.length > 0
    ) {
      var SrchResultMM_1 = new Array();
      var SrchResultDoc_1 = new Array();
      var SrchResultDemo_Live_1 = new Array();
      var SrchResultDemo_Lab_1 = new Array();
      var SrchResultDemo_Interactive_1 = new Array();

      this.state.searchResultData.map((item) => {
        if (item.Content_Type === "Multimedia") {
          SrchResultMM_1.push(item);
        }
        if (item.Content_Type === "Document") {
          SrchResultDoc_1.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Live"
        ) {
          SrchResultDemo_Live_1.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Lab"
        ) {
          SrchResultDemo_Lab_1.push(item);
        }
        if (
          item.Content_Type === "Physical" &&
          item.PhyContent_Category === "Interactive"
        ) {
          SrchResultDemo_Interactive_1.push(item);
        }
      });
      if (SrchResultDemo_Live_1.length > 0) {
        this.doTabCheck(0);
      } else if (SrchResultDemo_Lab_1.length > 0) {
        this.doTabCheck(1);
      } else if (SrchResultDemo_Interactive_1.length > 0) {
        this.doTabCheck(2);
      } else if (SrchResultMM_1.length > 0) {
        this.doTabCheck(3);
      } else if (SrchResultDoc_1.length > 0) {
        this.doTabCheck(4);
      } else {
        this.doTabCheck(0);
      }
    } */
    /*     if (this.state.searchResultData != undefined) {
      this.doTabCheck(0);
    } */

    console.log("Current Tab value is ", this.state.TabIndex);
    console.log("Live Demos are ", SrchResultDemo_Live);
    console.log("Lab Demos are ", SrchResultDemo_Lab);
    console.log("Interactive Demos are ", SrchResultDemo_Interactive);

    //this.OnActivate(4);

    if (this.state.filterON && this.state.srchResBackupData) {
      var multichips = "";
      if (
        this.state.ArrExpSelect &&
        this.state.ArrExpSelect.length > 0 &&
        this.state.filterON
      ) {
        this.state.ArrExpSelect.map((exp) => {
          if (multichips.length > 0) {
            multichips = multichips + " , " + exp;
          } else {
            multichips = exp;
          }
        });
      }
      console.log("Mutiple Exp Level selected are ", multichips);
      chippingcontent = (
        <Box
          align="center"
          justify="center"
          direction="row"
          gap="small"
          pad="small"
          key="small"
        >
          {multichips.length > 0 && this.state.filterON && (
            <Chip label={multichips} color="yellow" />
          )}
          {this.state.Lang && this.state.filterON && (
            <Chip label={this.state.Lang} color="yellow" />
          )}
        </Box>
      );

      //this.OnActivate(0);
    }

    if (this.state.bshowloader && this.state.searchResultData === undefined) {
      spinnercontent = (
        <Box
          align="center"
          justify="center"
          direction="row"
          gap="small"
          pad="small"
          key="small"
        >
          <Spinner size="large" />
          <Text size="large">Loading...</Text>
        </Box>
      );
    }

    var bShowDemoDet = this.state.bShowDemoDetail;

    var searchValueDisp = this.props.srchVal;

    if (this.props.srchVal === "WhatsNew") {
      searchValueDisp = "Recently published contents";
    }

    if (this.props.srchVal === "HowtoUse") {
      searchValueDisp = "How to use HPE Demo Portal";
    }

    if (this.props.srchVal === "GreenLake") {
      searchValueDisp = "HPE GreenLake Contents";
    }

    if (this.props.srchVal === "engageforbriefing") {
      searchValueDisp = "Engage For Briefing(s)";
    }

    if (this.props.viaFav) {
      searchValueDisp = "My Favorite(s)";
    }

    console.log("This time Multimedia items are ", SrchResultMM);

    const RichTabTitle = ({ icon, label }) => (
      <Box
        direction="row"
        align="center"
        // fill="horizontal"
        gap="xsmall"
        margin="small"
        //border={true}
        // color="brand"
      >
        {icon}
        <Text size="large">
          <strong>{label}</strong>
        </Text>
      </Box>
    );

    return (
      <Layer full="true" position="center">
        <Box fill="horizontal" align="stretch" justify="start">
          <Main
            overflow="auto"
            // overflow={{ vertical: "scroll" }}
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <AppHeader />
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
              elevation="large"
              // round="medium"
            >
              <Box
                align="stretch"
                justify="start"
                flex="grow"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
                elevation="medium"
                round="xsmall"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/*                 <Button
                  label="Back"
                  icon={<FormPrevious />}
                  gap="xsmall"
                  // onClick={() => push("/home")}
                /> */}
                  <Heading margin="none">
                    {this.props.isDemoIdSrch
                      ? "Search result for Demo ID - "
                      : ""}
                    {this.props.srchObj && !this.props.isDemoIdSrch
                      ? this.props.srchObj.MetadataName
                      : searchValueDisp}
                  </Heading>
                </Header>
                <Header
                  align="center"
                  direction="row"
                  flex={false}
                  justify="start"
                  gap="medium"
                >
                  <Box
                    align="center"
                    justify="end"
                    direction="row"
                    //onClick={[{ screen: 106, label: "3 - Listview", key: 106 }]}
                  >
                    <DropButton
                      label="Filter"
                      open={this.state.OnFilterOpen}
                      onOpen={this._OnFilterOpen}
                      dropAlign={{ top: "bottom" }}
                      dropContent={
                        <Box
                          align="center"
                          justify="center"
                          pad="medium"
                          name="dropContent"
                        >
                          <Form>
                            <FormField label="Expertise Level">
                              <CheckBoxGroup
                                value={this.state.ArrExpSelect}
                                options={[
                                  "Introductory",
                                  "Intermediate",
                                  "Expert",
                                ]}
                                onChange={(event) => {
                                  this.setExpLevelValue(event.value);
                                }}
                                disabled={this.state.filterON}
                              />
                            </FormField>
                            <FormField label="Languages / Subtitles">
                              <SingleSelect
                                value={this.state.Lang}
                                options={[
                                  "French",
                                  "Russian",
                                  "Japanese",
                                  "Spanish",
                                  "German",
                                ]}
                                onChange={this.setLangChange}
                                disabled={this.state.filterON}
                              />
                            </FormField>
                          </Form>
                          <Box
                            align="center"
                            justify="center"
                            direction="row"
                            gap="medium"
                            pad="large"
                          >
                            <Button
                              label="Apply filters"
                              primary
                              onClick={this.ApplyFilter}
                              disabled={this.state.filterON}
                            />
                            <Button
                              label="Reset filters"
                              secondary
                              disabled={!this.state.filterON}
                              onClick={this.ResetFilter}
                            />
                          </Box>
                        </Box>
                      }
                      icon={<Filter />}
                      primary={false}
                      reverse={false}
                      secondary={false}
                      plain={false}
                    />
                  </Box>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Box
                    align="center"
                    justify="center"
                    direction="row"
                    gap="xsmall"
                  >
                    {/* <Box
                      align="center"
                      justify="center"
                      round="large"
                      border={{ color: "brand" }}
                      background={{ color: "brand" }}
                    > */}
                    {chippingcontent}
                    {/* </Box> */}
                    {/* <Box align="center" justify="center" round="large" border={{"color":"blue"}} background={{"color":"blue!"}}>
                  <Text color="white">
                    French
                  </Text>
                </Box> */}
                  </Box>
                  <Box align="end" justify="end" fill="horizontal">
                    <Box
                      align="center"
                      justify="center"
                      border={{ color: "brand", size: "medium" }}
                      round="full"
                      background={{ color: "brand" }}
                      elevation="small"
                      animation="pulse"
                    >
                      <Text color="white">
                        {this.state.searchResultData
                          ? this.state.searchResultData.length
                          : 0}
                      </Text>
                    </Box>
                  </Box>
                </Header>
                <Box
                  align="stretch"
                  justify="center"
                  flex="grow"
                  // background={{ color: "background-front" }}
                >
                  {spinnercontent}
                  {/*                   {bShowDemoDet && (
                    <LiveDemoDetail
                      _demoData={datum}
                      hide={this._hideDemoDetail}
                    />
                  )} */}

                  <Tabs
                    justify="stretch"
                    flex="grow"
                    margin="xsmall"
                    activeIndex={this.state.TabIndex}
                    onActive={(index) => {
                      this.OnActivate(index);
                    }}
                  >
                    <Tab
                      // title="All"
                      title={<RichTabTitle icon={""} label="All" />}
                      // icon={<Console />}
                      // plain={false}
                      // reverse={false}
                      // name="All"
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultAll != undefined &&
                          SrchResultAll.length > 0 &&
                          SrchResultAll.map((datumLvv) => {
                            return (
                              <DemoListViewCard
                                _demo={datumLvv}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                    </Tab>
                    {/* <Tab
                      title="Demos"
                      icon={<Console />}
                      plain={false}
                      reverse={false}
                    >
                      <List data={SrchResultDemo}>
                        {(datum, index) => (
                          <DemoListView
                            _demo={datum}
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List>
                    </Tab> */}
                    <Tab
                      title={
                        <RichTabTitle
                          icon={<Console size="large" color="brand" />}
                          label="Live"
                        />
                      }
                      //title="Live"
                      // icon={<Console size="large" color="brand" />}
                      // plain={false}
                      // reverse={false}
                      // name="Live"
                      disabled={
                        SrchResultDemo_Live != undefined &&
                        SrchResultDemo_Live.length > 0
                          ? false
                          : true
                      }
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultDemo_Live != undefined &&
                          SrchResultDemo_Live.length > 0 &&
                          SrchResultDemo_Live.map((datumLv) => {
                            return (
                              <DemoListViewCard
                                _demo={datumLv}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                      {/*                       <List data={SrchResultDemo_Live}>
                        {(datumLv, index) => (
                          <DemoListView
                            _demo={datumLv}
                            _type="Live"
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List> */}
                    </Tab>
                    <Tab
                      title={
                        <RichTabTitle
                          icon={<Codepen size="large" color="blue!" />}
                          label="Lab"
                        />
                      }
                      // title="Lab"
                      //  icon={<Codepen size="large" color="darkblue" />}
                      // plain={false}
                      // reverse={false}
                      // name="Lab"
                      disabled={
                        SrchResultDemo_Lab != undefined &&
                        SrchResultDemo_Lab.length > 0
                          ? false
                          : true
                      }
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultDemo_Lab != undefined &&
                          SrchResultDemo_Lab.length > 0 &&
                          SrchResultDemo_Lab.map((datumLb) => {
                            return (
                              <DemoListViewCard
                                _demo={datumLb}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                      {/*                       <List data={SrchResultDemo_Lab}>
                        {(datumLb, index) => (
                          <DemoListView
                            _demo={datumLb}
                            _type="Lab"
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List> */}
                    </Tab>
                    <Tab
                      title={
                        <RichTabTitle
                          icon={<Gateway size="large" color="purple!" />}
                          label="Interactive"
                        />
                      }
                      //  title="Interactive"
                      //  icon={<Gateway size="large" color="lightgreen" />}
                      // plain={false}
                      //  reverse={false}
                      //  name="Inteactive"
                      disabled={
                        SrchResultDemo_Interactive != undefined &&
                        SrchResultDemo_Interactive.length > 0
                          ? false
                          : true
                      }
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultDemo_Interactive != undefined &&
                          SrchResultDemo_Interactive.length > 0 &&
                          SrchResultDemo_Interactive.map((datumIT) => {
                            return (
                              <DemoListViewCard
                                _demo={datumIT}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                      {/*                       <List data={SrchResultDemo_Interactive}>
                        {(datumI, index) => (
                          <DemoListView
                            _demo={datumI}
                            _type="Interactive"
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List> */}
                    </Tab>
                    <Tab
                      title={
                        <RichTabTitle
                          icon={<Video size="large" color="blue" />}
                          label="Videos"
                        />
                      }
                      // title="Videos"
                      //  icon={<Video size="large" color="blue" />}
                      disabled={
                        SrchResultMM != undefined && SrchResultMM.length > 0
                          ? false
                          : true
                      }
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultMM != undefined &&
                          SrchResultMM.length > 0 &&
                          SrchResultMM.map((datumMM) => {
                            return (
                              <DemoListViewCard
                                _demo={datumMM}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                      {/* <List data={SrchResultMM}>
                        {(datumv, index) => (
                          <MMListView
                            _mmcontent={datumv}
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List> */}
                    </Tab>
                    <Tab
                      title={
                        <RichTabTitle
                          icon={<DocumentPdf size="large" color="dark-3" />}
                          label="Documents"
                        />
                      }
                      //  title="Documents"
                      //  icon={<DocumentPdf size="large" color="dark-3" />}
                      disabled={
                        SrchResultDoc != undefined && SrchResultDoc.length > 0
                          ? false
                          : true
                      }
                    >
                      <Grid
                        columns={{ size: "medium", count: "fill" }}
                        gap="medium"
                        rows="small"
                        width="xlarge"
                        pad="medium"
                        // columns={["flex", "flex", "flex"]}
                        //columns={["medium", "medium", "medium"]}
                        // fill="horizontal"
                        // pad="small"
                        // gap="medium"
                      >
                        {SrchResultDoc != undefined &&
                          SrchResultDoc.length > 0 &&
                          SrchResultDoc.map((datumDC) => {
                            return (
                              <DemoListViewCard
                                _demo={datumDC}
                                // AllDemos={SrchResultDemo_Live}
                                _type="Live"
                                calledBy={this.props.calledBy}
                                // indexval={index}
                                hide={this.closeitself}
                              />
                            );
                          })}
                        ;
                      </Grid>
                      {/*                       <List data={SrchResultDoc}>
                        {(datumd, index) => (
                          <DocListView
                            _doccontent={datumd}
                            calledBy={this.props.calledBy}
                            hide={this.closeitself}
                          />
                        )}
                      </List> */}
                    </Tab>
                  </Tabs>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}
export default ListView;
